import { render, staticRenderFns } from "./info.vue?vue&type=template&id=5d917ec8&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=5d917ec8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d917ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d917ec8')) {
      api.createRecord('5d917ec8', component.options)
    } else {
      api.reload('5d917ec8', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=5d917ec8&scoped=true", function () {
      api.rerender('5d917ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/info.vue"
export default component.exports